export class DateInput {
  constructor(
    public value?: string,
    public status?: string,
    public message?: string
  ) {}
}
